import { render, staticRenderFns } from "./secondaryButtonDropdown.vue?vue&type=template&id=0b616786"
import script from "./secondaryButtonDropdown.vue?vue&type=script&lang=js"
export * from "./secondaryButtonDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports